import { useReducer, useCallback, useEffect, useState } from "react";
import { CacheKeys, useCacheContext } from "../Cache";
import {
  ACTION_KEYS,
  DEFAULT_STATE,
  releasePacksReducer,
} from "./ReleasePacks.reducer";
import { Api } from "../../api";

export const useReleasePacks = () => {
  const [state, dispatch] = useReducer(releasePacksReducer, DEFAULT_STATE);
  const { getFromCache, saveToCache } = useCacheContext();

  const setIterations = useCallback(async () => {
    const iterations = getFromCache(CacheKeys.iterations);

    if (iterations == null) {
      const iterations = await Api.getIterations();
      saveToCache(CacheKeys.iterations, iterations.data);
      dispatch({ type: ACTION_KEYS.SET_ITERATIONS, payload: iterations.data });

      const currentIteration = iterations.data.filter(
        (i: any) => i?.attributes?.timeFrame == "current"
      )[0];

      dispatch({ type: ACTION_KEYS.SET_ITERATION, payload: currentIteration });

      onSelectIteration(currentIteration.id);
    }
  }, [getFromCache]);

  const fetchPrdWorkItems = async (iteration: any) => {
    const prdCompletedWorkItems =
      await Api.getCompletedWorkItemsByIterationAndTarget(
        iteration.id,
        "master"
      );

    dispatch({
      type: ACTION_KEYS.SET_PRD_COMPLETED_WORKITEMS,
      payload: {
        prdCompletedWorkItems: prdCompletedWorkItems.data,
        isLoading: false,
      },
    });
  };

  const fetchUatWorkItems = async (iteration: any) => {
    const uatCompletedWorkItems =
      await Api.getCompletedWorkItemsByIterationAndTarget(
        iteration.id,
        "release"
      );

    dispatch({
      type: ACTION_KEYS.SET_UAT_COMPLETED_WORKITEMS,
      payload: { uatCompletedWorkItems: uatCompletedWorkItems.data },
    });
  };

  const fetchAllWorkItems = async (iteration: any) => {
    const workItems = await Api.getIterationWorkItems(iteration.id);

    dispatch({
      type: ACTION_KEYS.SET_WORKITEMS,
      payload: { workItems: workItems.data },
    });
  };

  const onSelectIteration = useCallback(async (value: any) => {
    const iterations = getFromCache(CacheKeys.iterations);
    const iteration = iterations.find((i: any) => i.id == value);

    if (iteration) {
      dispatch({ type: ACTION_KEYS.SET_ITERATION, payload: iteration });

      await fetchAllWorkItems(iteration);
      await fetchUatWorkItems(iteration);
      await fetchPrdWorkItems(iteration);
    }
  }, []);

  useEffect(() => {
    setIterations();
    // eslint-disable-next-line
  }, []);

  const {
    iterations,
    selectedIteration,
    workItems,
    uatWorkItems,
    uatCompletedWorkItems,
    prdWorkItems,
    prdCompletedWorkItems,
    isLoading,
  } = state;

  return {
    iterations,
    selectedIteration,
    workItems,
    uatWorkItems,
    uatCompletedWorkItems,
    prdWorkItems,
    prdCompletedWorkItems,
    isLoading,
    onSelectIteration,
  } as const;
};
